module.exports = __webpack_public_path__ + "img/header.661a1b7e.jpg";